
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/DataGrid/columns",
      function () {
        return require("private-next-pages/components/DataGrid/columns.mdx");
      }
    ]);
  